






import { Component, Vue } from 'vue-property-decorator';
import Referenzen from './components/Referenzen.vue';

@Component({
  components: {
    Referenzen,
  },
})
export default class App extends Vue {}
